import { createTheme } from "@mui/material";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "Instrument Sans, sans-serif"
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: () => ({
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '16px',
        })
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          textTransform: 'none',
          height: "30px",
          boxShadow: 'none',
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '16px',
          color: '#fff',
          '&.Mui-disabled': {
            cursor: 'not-allowed',
            pointerEvents: 'auto',
          },
          '&:hover': {
            boxShadow: 'none',
          },
          [theme.breakpoints.down('md')]: {
            fontSize: '14px',
          },
        }),
      },
      defaultProps: {
        variant: 'contained',
        size: 'small',
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: 'Instrument Sans, sans-serif',
          fontSize: '16px',
          fontWeight: 400,
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          fontFamily: 'Instrument Sans, sans-serif',
          fontSize: '16px',
          fontWeight: 400,
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          fontFamily: "Instrument Sans, sans-serif",
          fontSize: "16px",
          fontWeight: 400,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: "Instrument Sans, sans-serif",
          fontSize: "16px",
          fontWeight: 400,
          padding: 0,
          borderBottom: "1px solid #b4b4b4",
          paddingTop: '11px',
          paddingBottom: '11px',
          color: "rgba(0,0,0,1)"
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          fontFamily: "Instrument Sans, sans-serif",
          fontSize: "16px",
          fontWeight: 400,
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          fontFamily: "Instrument Sans, sans-serif",
          fontSize: "16px",
          fontWeight: 400,
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          position: 'relative',
          justifyContent: 'center',
          color: 'black',
          '&.Mui-active': {
            color: '#2252A5',
          },
          '&.Mui-active .MuiTableSortLabel-icon': {
            color: '#2252A5',
          },
          '&:hover': {
            color: '#2252A5',
            '& .MuiTableSortLabel-icon': {
              color: '#2252A5',
              opacity: 1
            },
          },
          "&:focus-visible": {
            outline: "2px solid #2252A5",
            outlineOffset: "2px",
            borderRadius: "2px",
            color: "#2252A5",
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#ffffff',
      v2: '#ebebeb',
      v3: '#fefefe',
    },
    secondary: {
      main: '#8a8a8a',
      v2: "#f2f2f2",
      v3: "#B8B8B8",
      v4: "#B4B4B4",
      v5: "#f5f5f5",
      v6: "#595959",
      v7: '#515864',
    },
    info: {
      main: '#2252A5',
    },
    text: {
      main: "rgba(0,0,0,1)",
      light: "#ffffff",
      secondary: '#818181',
      dark: '#585858',
      icon: '#4d4d4d',
      orangeIcon: "#ff6f00",
      blueIcon : "#2252a5"
    },
    success: {
      main: '#4CAF50',
    },
    warning: {
      main: '#FFC107',
    },
    error: {
      main: '#F44336',
    },
  },
});

export default theme;
